module.exports = __webpack_public_path__ + "img/liyu.3dd38b13.jpg";